var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "limit-price-wrapper" }, [
    _c("div", { staticClass: "__center-title" }, [
      _vm._v(
        "\n        " + _vm._s(_vm.$t("trade.limitPrice.title")) + "\n\n        "
      ),
      _c(
        "div",
        { staticClass: "right-tab" },
        [
          _c("Vip"),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              _vm._s(_vm.$t("trade.limitPrice.fee")) + "\n                "
            ),
            _c("span", { staticClass: "fee" }, [
              _vm._v(
                "Taker(" +
                  _vm._s(_vm.exTakerFee) +
                  ") / Maker(" +
                  _vm._s(_vm.exMakerFee) +
                  ")"
              )
            ])
          ]),
          _vm._v(" "),
          !_vm.isZeroFee
            ? _c(
                "span",
                {
                  staticClass: "help __pointer",
                  on: { mouseenter: _vm.showHelp, mouseleave: _vm.hideHelp }
                },
                [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowHelp,
                          expression: "isShowHelp"
                        }
                      ],
                      staticClass: "help-tip"
                    },
                    [
                      _vm.isSVip
                        ? _c("span", [
                            _vm._v(_vm._s(_vm.$t("trade.limitPrice.svipFee")))
                          ])
                        : _c("span", { staticStyle: { color: "red" } }, [
                            _vm._v(
                              _vm._s(_vm.$t("trade.limitPrice.adviseToSVip"))
                            )
                          ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("trade.limitPrice.dexFee", {
                              fee: _vm.baseFee
                            })
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("trade.limitPrice.operatorFee", {
                              fee: _vm.operatorFee
                            })
                          )
                        )
                      ]),
                      _vm._v(" "),
                      !_vm.isSVip
                        ? _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("trade.limitPrice.vipFee", {
                                  fee: _vm.vipFee
                                })
                              )
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("trade.limitPrice.inviteFeeDiscount", {
                              fee: _vm.inviteFeeDiscount
                            })
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _vm.isSVip
                        ? _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("trade.limitPrice.feeRuleWithSVip"))
                            )
                          ])
                        : _c("span", [
                            _vm._v(_vm._s(_vm.$t("trade.limitPrice.feeRule")))
                          ])
                    ]
                  )
                ]
              )
            : _vm._e()
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "ex-center-login" },
      [
        _c("order", { attrs: { orderType: "buy" } }),
        _vm._v(" "),
        _c("div", { staticClass: "order-border" }),
        _vm._v(" "),
        _c("order", {
          staticClass: "order-wrapper",
          attrs: { orderType: "sell" }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }